<template>
  <div class="preloader-luxury">
    <div class="glass-surface preloader-luxury__card">
      <div class="preloader-luxury__logo">
        <img :src="image" alt="Fomo Planes" />
      </div>
      <h2 class="preloader-luxury__title">Validando disponibilidad</h2>
      <p class="preloader-luxury__text">
        Estamos preparando la siguiente etapa del flujo de compra para que tu experiencia se mantenga clara y sin friccion.
      </p>
      <div class="checkout-step__loader preloader-luxury__loader-wrap">
        <div class="glass-topbar__indicator" style="position: relative; width: 88px; height: 88px; transform: none;">
          <div class="glass-topbar__indicator-glow"></div>
          <div class="glass-topbar__indicator-clip">
            <div class="glass-topbar__indicator-ring"></div>
          </div>
          <div class="glass-topbar__indicator-plate"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreloaderComponent',

  data() {
    return {
      image: '/static/FOMOPLANES_isotipo_512.png',
    }
  },
}
</script>

<style>
.preloader-luxury__logo {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}

.preloader-luxury__logo img {
  width: 84px;
  height: 84px;
  object-fit: contain;
  filter: drop-shadow(0 12px 26px rgba(142, 111, 198, 0.24));
}
</style>
